// src/components/Store/SnapshotStreamingStore.js

import { create } from 'zustand';

const useSnapshotStreamingStore = create(set => ({
  spxSnapshot: null,

  setSpxSnapshot: snapshot =>
    set({
      spxSnapshot: {
        symbol: 'SPX',
        current: snapshot?.current ?? null,
        previousClose: snapshot?.previousClose ?? null,
        change: snapshot?.change ?? null,
        changePercent: snapshot?.changePercent ?? null,
      },
    }),

  clearSpxSnapshot: () =>
    set({
      spxSnapshot: null,
    }),
}));

export default useSnapshotStreamingStore;